<template>
  <div class="cycle-table summary-page page-box">
    <div class="header">
      <el-select
        size="small"
        v-model="status"
        class="header-item"
        clearable
        @change="toQuery"
        style="margin-right: 5px;width: 150px;"
        :placeholder="$t('state')"
      >
        <el-option
          v-for="(item,index) in statusList"
          :key="index"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-input
        size="small"
        class="header-item"
        clearable
        style="width: 150px; "
        :placeholder="phFileter(`${$t('Customer_nickname')}/MT4`, self)"
        v-model="nickNameOrMt4"
        @keyup.enter.native="toQuery"
      ></el-input>
      <el-button
        size="small"
        class="header-item"
        type="primary"
        style="margin-left: 5px"
        @click="seachHandle"
      >{{$t('root.search')}}</el-button>
    </div>
    <div class="el-table-outer">
      <el-table
        :data="listData"
        :empty-text="$t('root.noData')"
        v-loading="loading"
        class="el-table-el"
        @sort-change="sortChange"
        :header-cell-style="{ background: '#F3F2F7',color: '#5E5873' }"
        show-summary
        :summary-method="getSummaries"
      >
        <div class="table-nodata" slot="empty">
          {{$t('root.noData')}}
        </div>
<!--        <el-table-column
          :label="$t('Issue')"
          prop="issueNumber"
          min-width="140px"
        >
        </el-table-column>-->
        <el-table-column
          :label="$t('client')"
          prop="order"
          min-width="160px"
        >
          <template slot-scope="scope">
            <div class="">{{scope.row.alias}}</div>
            <span class="font999">{{scope.row.login}}</span>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('Management_days')"
          prop="times"
          sortable
          min-width="100px"
        >
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" :content="`${scope.row.beginDate} ~ ${getToday()}`" placement="top">
                        <span
                          class=""
                        >{{scope.row.times}}{{$t('day')}}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('User.commissionBanlance')"
          prop="balance"
          sortable
          min-width="100px"
        >
        </el-table-column>

        <el-table-column
          :label="$t('Manage_funds')"
          sortable
          prop="managementAmount"
          min-width="100px"
        >
        </el-table-column>
        <el-table-column
          :label="$t('Management_income')"
          prop="statProfit"
          sortable
          min-width="100px"
        >
          <template slot-scope="scope">
              <span class=""
                              :class="{
                            'warning-red': isIncludeMinus(scope.row.statProfit),
                            'theme-green': !isIncludeMinus(scope.row.statProfit),
                            }"
                        >{{scope.row.statProfit}}</span>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('management_rate_of_return')"
          sortable
          prop="manageProfitRate"
          min-width="110px"
        >
        </el-table-column>
        <el-table-column
          :label="$t('management_fee')"
          sortable
          prop="price"
          min-width="100px"
        >
        </el-table-column>
        <el-table-column
          :label="$t('Performance_fee')"
          min-width="100px"
          sortable
          prop="performancePrice"
        >
          <template slot-scope="scope">
            <!--进行中和结算中的就是估算值,因为表现费有可能浮动 -->
            <span>{{scope.row.performancePrice}} <span v-if="getEstimate(scope.row.type)">({{$t('Estimate')}})</span></span>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('User.status')"
          prop="status"
          min-width="100px"
        >
          <template slot-scope="scope">
            <span
              class="status tag-box"
              :style="getStyle(scope.row.type)"
            >{{getStatus(scope.row.type)}}</span>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('withgold.operating')"
          prop="operating"
        >
          <template slot-scope="scope">
            <el-tooltip
              v-if="getDisabledBtnShow(scope.row)"
              class="item" effect="dark"
              placement="top"
            >
              <div class="" slot="content" style="width: 136px">
                <p>{{$t('Settlement_conditions')}}:</p>
                <p>1.{{$t('cycleTips1')}}</p>
                <p> 2.{{$t('cycleTips2')}}</p>
              </div>
              <span
                class="gray-btn">{{$t('settle')}}</span>
            </el-tooltip>

            <span
              class="pointer enable-btn"
              v-if="getSettleBtnShow(scope.row)"
              @click="settleHandle(scope.row)">{{$t('settle')}}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div
      class="pagination-outer"
      v-if="total"
    >
      <div class="paginnation-left">
        <size-change @sizeChange="sizeChange"></size-change>
        <span class="tatol-count">{{$t('total')}} {{total}} {{$t('item')}}</span>
      </div>
      <vs-pagination
        class="pagination-box"
        :max="max"
        :total="pageSize"
        v-model="page"
      ></vs-pagination>
    </div>
  </div>
</template>

<script>
import {colorRgba, init_date} from '@/utils'
import { settleOne } from '@/api/copy'
import { isIncludeMinus,phFileter } from '@/utils/common';
import { mapGetters } from 'vuex';
import initData2 from '@/mixins/initData';
export default {
  name: 'tableModules',
  props: {
    rowData: {},
  },
  mixins: [initData2],
  data() {
    return {
      statistics: {
        times: 0,
        balance: '',
        managementAmount: '',
        statProfit: '',
        manageProfitRate: '',
        price: '',
        performancePrice: '',
      },
      nickNameOrMt4: '',
      self: {},

      status: '',
      statusList: [
        { label: this.$t('withgold.statusDuring'),value: 1 },
        { label: this.$t('Settlement'),value: 2 },
        { label: this.$t('Pending_settlement'),value: 3 },
        { label: this.$t('settled'),value: 4 },
      ],

      green: '#28C76F',
      yellow: '#FF9F43',
      grayBg: '#BABFC7',
      grayColor: '#BABFC7',
    };
  },
  created(){
    this.self = this;
  },
  mounted() {
    this.$nextTick(() => {
      if(this.rowData.id){
        this.init();
      }
    })
  },
  watch:{
    listRefresh(){
      this.seachHandle();
    },
    rowData: {
      handler(val){
        if(val){
          this.seachHandle();
        }
      },
      deep: true,
    }
  },
  computed: {
    ...mapGetters(['userInfo','listRefresh']),
  },
  methods: {
    isIncludeMinus,
    phFileter,
    getEstimate(type){
      if(type == 1 ||  type == 2 ||  type == 3){
        return true;
      }
    },
    getDisabledBtnShow(row){
      return row.type == 1 && row.times < 15;
    },
    getSettleBtnShow(row){
      return row.type == 1 && row.times >= 15;
    },
    beforeInit(){
      if(!this.rowData)
        return false;
      this.params = {
        cycleId: this.rowData.id,
        page: this.page - 1,
        size: this.size,
      }
      if(this.sort){
        this.params.sort = this.sort
      }
      if(this.nickNameOrMt4){
        this.params.custInfo = this.nickNameOrMt4;
      }
      if(this.status){
        this.params.type = this.status;
      }
      this.url = `/crm/reception/queryToBeSettledList`;
      return true;
    },
    getToday(){
      return init_date().today;
    },
    settleHandle(row){
      this.$confirm(this.$t('settleBeforeTips'),this.$t('Confirm_settlement'), {
        confirmButtonText: this.$t('root.confirm'),
        cancelButtonText: this.$t('root.cancle'),
        type: 'warning',
        customClass: 'self-messagebox-wrapper'
      }).then(() => {
        settleOne({
          subId: row.id,
        }).then((res) => {
          this.$message({
            message: this.$t('Settled_successfully'),
            type: 'success'
          });
          this.loading = true;
          setTimeout(() => {
            this.loading = false;
            this.seachHandle();
          },1000);
        })
      }).catch(() => {
        //几点取消的提示
      });
    },
    seachHandle(){
      this.page = 1;
      this.init();
    },
    getStyle(type) {
      if(type == 1){
        return {
          backgroundColor: colorRgba(this.green,0.12),
          color: this.green,
        }
      }else if(type == 2 || type == 3){
        return {
          backgroundColor: colorRgba(this.yellow,0.12),
          color: this.yellow,
        }
      }else if(type == 4){
        return {
          backgroundColor: colorRgba(this.grayBg,0.12),
          color: '#626262',
        }
      }
    },
    getStatus(type){
      switch (type) {
        case 1:
          return this.$t('withgold.statusDuring');
        case 2:
          return this.$t('Settlement');
        case 3:
          return this.$t('Pending_settlement');
        case 4:
          return this.$t('settled');
      }
    },

    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        switch (column.property) {
          // todo 联调
          case 'order':
            sums[index] = this.$t('User.total');
            break;
          case 'times':
          case 'status':
          case 'operating':
          case 'manageProfitRate':
            sums[index] = `-`;
            break;
          case 'balance':
            sums[index] = `${this.statistics.totalBalance}`;
            break;
          case 'managementAmount':
            sums[index] = `${this.statistics.totalManagementAmount}`;
            break;
          case 'statProfit':
            sums[index] = `${this.statistics.totalManagementProfit}`;
            break;
          case 'price':
            sums[index] = `${this.statistics.totalManagementPrice}`;
            break;
          case 'performancePrice':
            sums[index] = `${this.statistics.totalPerformancePrice}`;
            break;

        }
      });
      return sums;
    },
  },
};
</script>

<style lang="scss" scoped>
.cycle-table {
  .header {
    padding: 20px;
    .header-item {
      margin-bottom: 10px;
    }
  }
  .tag-box {
    padding-left: 10px;
    padding-right: 10px;
  }
  .gray-btn {
    color: #A29FAE;
  }
  .enable-btn {
    color: #6E6B7B ;
  }
}
</style>
